import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./TopNavigation.vue?vue&type=style&index=0&id=4aee065a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_typescript@5.1.6__webpack@5.99.6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aee065a"]])

export default __exports__